import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { SECTIONS } from "@/lib/sections";
import { ArticleList } from "@/components/site/ArticleItem";
import NotFound from "@/pages/NotFound";

export default function SectionPage() {
  const { slug } = useParams();
  const section = SECTIONS.find((s) => s.slug === slug);
  const [articles, setArticles] = useState(null);

  useEffect(() => {
    if (!section) return;
    setArticles(null);
    api.get("/articles", { params: { section: slug } }).then((r) => setArticles(r.data));
  }, [slug, section]);

  if (!section) return <NotFound />;
  return (
    <div className="max-w-3xl pt-14" data-testid={`section-page-${slug}`}>
      <p className="meta">Section</p>
      <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight" data-testid="section-title">{section.name}</h1>
      <p className="mt-4 text-[var(--ink-2)] text-lg">{section.blurb}</p>
      <p className="mt-6 pb-3 border-b border-[var(--ink)] meta" data-testid="section-count">
        {articles ? `${articles.length} ${articles.length === 1 ? "piece" : "pieces"}` : "Loading"}
      </p>
      {articles && <ArticleList articles={articles} testId="section-articles" />}
    </div>
  );
}
